const { deepCopy } = require('../../assets/functions/deepCopy');

const defaultProfile = {
  storeInfo: {
    deviceInfo: [],
    mainProductInfo: [],
    productTypeInfo: [],
    transactionTypeInfo: [],
    productGroupByTypeInfo: [],
    paymentType: [],
    setting: {},
  },
  token: '',
  no: '',
  orderNo: '',
  tableIndexNo: '',
  people: false,
  extPos: {
    label: '',
    counterNo: '',
  },
  skipBeforeOrder: false,
};
const state = {
  profile: { ...defaultProfile },
  subStores: [],
};

const mutations = {
  SET_PROFILE(state, profile) {
    state.profile = profile;
  },
  CLEAN_PROFILE(state) {
    state.profile = deepCopy(defaultProfile);
  },
  SET_SUB_STORES(state, subStores) {
    state.subStores = subStores;
  },
};

const actions = {
  setProfile({ commit }, payload) {
    commit('SET_PROFILE', payload);
  },
  cleanProfile({ commit }) {
    return new Promise((resolve) => {
      commit('CLEAN_PROFILE');
      resolve();
    });
  },
  setSubStores({ commit }, payload) {
    commit('SET_SUB_STORES', payload);
  },
};

const getters = {
  menus: (state) => state.profile.storeInfo.mainProductInfo,
  groupMenus: (state) => state.profile.storeInfo.productGroupByTypeInfo,
  category: (state) => state.profile.storeInfo.productTypeInfo,
  additionalProductInfo: (state) => state.profile.storeInfo.additionalProductInfo,
  printers: (state) => state.profile.storeInfo.deviceInfo.filter((item) => item.deviceTypeId === '201706000002'),
  token: (state) => state.profile.token,
  no: (state) => state.profile.no,
  orderNo: (state) => state.profile.orderNo,
  tableIndexNo: (state) => state.profile.tableIndexNo,
  people: (state) => state.profile.people,
  mainProductsById: (state) => {
    const _products = {};
    state.profile.storeInfo.mainProductInfo.forEach((p) => {
      _products[p.productId] = p;
    });
    return _products;
  },
  productTypeInfoById: (state) => {
    const _typeInfo = {};
    state.profile.storeInfo.productTypeInfo.forEach((p) => {
      _typeInfo[p.productTypeId] = p;
    });
    return _typeInfo;
  },
  extPos: (state) => state.profile.extPos,
  storeSetting: (state) => {
    if (state.profile.storeInfo.store) {
      return state.profile.storeInfo.store[0].setting;
    }
    return '';
  },
  store0: (state) => {
    if (state.profile.storeInfo.store) {
      return state.profile.storeInfo.store[0];
    }
    return {};
  },
  storePaymentType: (state) => {
    if (state.profile.storeInfo) {
      return state.profile.storeInfo.paymentType;
    }
    return '';
  },
  isDynamicQrcode: (state) => {
    if (state.profile.storeInfo.store) {
      return state.profile.storeInfo.store[0].isDynamicQrcode === 'Y';
    }
    return false;
  },
  isEnableDelivery: (state) => {
    if (state.profile.storeInfo.store) {
      return state.profile.storeInfo.store[0].isEnableDelivery === 'Y';
    }
    return false;
  },
  isTakeOutServiceFee: (state) => {
    if (state.profile.storeInfo.store) {
      return state.profile.storeInfo.store[0].setting.isTakeOutServiceFee === 'Y';
    }
    return false;
  },
  isLinePayTest: (state) => {
    if (state.profile.storeInfo.store) {
      return state.profile.storeInfo.store[0].isLinePayTest === 'Y';
    }
    return false;
  },
  deliveryVender: (state) => {
    const store = state.profile.storeInfo.store[0];
    if (store && store.setting.deliverySetting.deliveryVender
      && store.setting.deliverySetting.deliveryVender.length) {
      return store.setting.deliverySetting.deliveryVender[0];
    }
    return '';
  },
  tableInfo: (state) => {
    const infos = state.profile.storeInfo.tableInfo;
    return infos.map((info) => {
      const {
        tableId,
        tableName,
      } = info;
      return {
        tableId,
        tableName,
        tableStatus: 1,
      };
    });
  },
  storeId: (state) => state.profile.storeId,
  storeName: (state) => state.profile.storeInfo.store[0].storeName,
  calculateDefaultServiceFeeFunction: (state) => {
    if (state.profile.storeInfo.store) {
      const {
        serviceFee, isTakeOutServiceFee,
      } = state.profile.storeInfo.store[0].setting;
      return (amount, serviceCharge, diningIn) => {
        let _serviceCharge = serviceCharge;
        let _serviceFee = serviceFee;
        if (isTakeOutServiceFee === 'N' && (diningIn === 'to-go' || diningIn === 'delivery')) {
          _serviceCharge = 0;
          _serviceFee = 0;
        }
        const ratio = (parseInt(_serviceCharge || _serviceFee || '0', 10) / 100).toFixed(2);
        return amount * ratio;
      };
    }
    return 0;
  },
  decimalHandleFunction: (state) => {
    if (state.profile.storeInfo.store) {
      const {
        decimalType,
      } = state.profile.storeInfo.store[0].setting;
      if (decimalType === 1) {
        return Math.round;
      }
      if (decimalType === 2) {
        return Math.ceil;
      }
      if (decimalType === 3) {
        return Math.floor;
      }
    }
    return Math.round;
  },
  subStores: (state) => state.subStores,
  skipBeforeOrder: (state) => state.profile.skipBeforeOrder,

};

export default {
  state,
  mutations,
  getters,
  actions,
};
